import * as React from "react";
import { FC } from "react";
import { Create, CreateProps, SimpleForm } from "react-admin";
import { TitleRemoveReasonTypes } from "./Constant/Source";
import CreateRemoveReason from "./Forms/RemoveReasonCreateForm";

const RemoveReasonCreate: FC<CreateProps> = props => {
  return (
    <Create {...props} title={TitleRemoveReasonTypes.create}>
      <SimpleForm>
        <CreateRemoveReason />
      </SimpleForm>
    </Create>
  );
};

export default RemoveReasonCreate;
